import { proyectUrl } from 'proyectUrl';

export const strings = {
  english: {
    title: 'LOGIN',
    email: 'Email',
    password: 'Password',
    remember: 'Remember Me',
    lostPassword: "I don't remember my password",
    signIn: 'SIGN IN',
    or: 'Or',
    facebook: 'Continue with Facebook',
    google: 'Continue with Google',
    error: 'We did not receive any feedback from the plugin. Please, check if the plugin has been authenticated, and if not, try again using the button',
    support: 'Contact support',
    again: 'TRY AGAIN',
    success: 'To continue the process, close this window and go back to the WalkMix Creator plugin',
  },

  japan: {
    title: 'ログイン',
    email: 'メールアドレス',
    password: 'パスワード',
    remember: 'ログイン状態を保存',
    lostPassword: 'パスワードをお忘れですか ?',
    signIn: 'サインイン',
    or: 'または',
    facebook: 'Facebookを使ってサインインする',
    google: 'Googleを使ってサインインする',
    error: 'プラグインが応答しませんでした。認証が完了しているか確認してください。もし認証されていなければ、下のボタンをクリックして再試行してください。',
    support: 'お問い合わせ',
    again: '再試行',
    success: 'このプロセスを続けるには、この画面を閉じてWalkMix Creatorプラグインへ戻ってください。',
  },
};

export const supportLinks = {
  english: `${proyectUrl()}/support/`,
  japan: `${proyectUrl()}/jp/%e3%81%8a%e5%95%8f%e3%81%84%e5%90%88%e3%82%8f%e3%81%9b/`,
};
